import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { KeyRound, FileSearch, ClipboardCheck, Trash2, Clock, History } from 'lucide-react';

const typeMeta = {
  entra_id: { icon: KeyRound, label: 'Entra ID' },
  design_review: { icon: FileSearch, label: 'HLD/LLD Review' },
  security_assurance: { icon: ClipboardCheck, label: 'Security Assurance' },
};

export const AssessmentHistory = ({ items, onDelete }) => (
  <Card data-testid="assessment-history">
    <CardContent className="p-4 space-y-2">
      {items.length === 0 && <div className="text-center py-10 text-muted-foreground text-sm"><History className="h-8 w-8 mx-auto mb-2 opacity-30" />No assessments yet. Run one from the tabs above.</div>}
      {items.map(a => {
        const m = typeMeta[a.type] || typeMeta.entra_id;
        const issues = a.findings?.length ?? a.gaps?.length ?? 0;
        const color = a.score >= 75 ? 'text-green-500' : a.score >= 50 ? 'text-yellow-500' : 'text-red-500';
        return (
          <div key={a.assessment_id} className="flex items-center gap-3 p-3 rounded-lg border hover:bg-muted/40 transition-colors" data-testid={`assessment-${a.assessment_id}`}>
            <div className="p-2 rounded-lg bg-primary/10"><m.icon className="h-4 w-4 text-primary" /></div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{a.name} <span className="text-muted-foreground font-normal">· {a.review_type ? a.review_type.toUpperCase() : a.framework_name || a.domain || ''}</span></p>
              <p className="text-[11px] text-muted-foreground flex items-center gap-1"><Clock className="h-3 w-3" /> {new Date(a.created_at).toLocaleString()}</p>
            </div>
            <Badge variant="outline" className="text-[10px]">{m.label}</Badge>
            <span className="text-xs text-muted-foreground hidden sm:inline">{issues} issues</span>
            <span className={`text-lg font-bold font-heading ${color}`}>{a.score}</span>
            <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground hover:text-destructive" onClick={() => onDelete(a.assessment_id)} data-testid={`delete-assessment-${a.assessment_id}`}><Trash2 className="h-4 w-4" /></Button>
          </div>
        );
      })}
    </CardContent>
  </Card>
);
